import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CakeLogin.css';

const CakeLogin = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (message) {
      setMessage('');
      setMessageType('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email.trim() || !formData.password) {
      setMessage('Email and password are required.');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await fetch('/api/cake/auth/login', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          email: formData.email.trim(),
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || 'Login failed. Please try again.'
        );
      }

      if (!data.token) {
        throw new Error('Login token not received.');
      }

      // Save Cake Vendor Login
      localStorage.setItem('cakeToken', data.token);

      localStorage.setItem(
        'cakeVendor',
        JSON.stringify(data.vendor || {})
      );

      setMessage('Login successful.');
      setMessageType('success');

      setTimeout(() => {
        navigate('/cake/vendor');
      }, 700);

    } catch (error) {
      console.error('Cake login error:', error);

      setMessage(
        error.message || 'Something went wrong. Please try again.'
      );

      setMessageType('error');

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cake-login-page">

      {/* TOP BAR */}
      <header className="cake-login-topbar">

        <div
          className="cake-login-brand"
          onClick={() => navigate('/')}
        >
          <div className="cake-login-logo">
            🎂
          </div>

          <div>
            <h2>VAKRA CAKE</h2>
            <span>Cake Business Platform</span>
          </div>
        </div>


        <div className="cake-login-signup-link">
          New to VAKRA Cake?

          <button
            type="button"
            onClick={() => navigate('/cake/signup')}
          >
            Sign Up
          </button>
        </div>

      </header>


      {/* MAIN */}
      <main className="cake-login-main">

        {/* LEFT */}
        <section className="cake-login-left">

          <div className="cake-login-left-content">

            <div className="cake-login-badge">
              Welcome Back
            </div>

            <h1>
              Manage Your
              <span> Cake Business </span>
              from One Place
            </h1>

            <p>
              Login to manage your cakes, orders, customers,
              billing and business records.
            </p>


            <div className="cake-login-points">

              <div className="cake-login-point">
                <div className="cake-login-point-icon">
                  🎂
                </div>

                <div>
                  <strong>
                    Manage Cakes
                  </strong>

                  <span>
                    Add and update cake products easily.
                  </span>
                </div>
              </div>


              <div className="cake-login-point">
                <div className="cake-login-point-icon">
                  📦
                </div>

                <div>
                  <strong>
                    Manage Orders
                  </strong>

                  <span>
                    Track new, preparing, ready and completed orders.
                  </span>
                </div>
              </div>


              <div className="cake-login-point">
                <div className="cake-login-point-icon">
                  📊
                </div>

                <div>
                  <strong>
                    View Records
                  </strong>

                  <span>
                    Keep your sales and customer records organized.
                  </span>
                </div>
              </div>

            </div>

          </div>

        </section>


        {/* RIGHT */}
        <section className="cake-login-right">

          <div className="cake-login-card">

            <div className="cake-login-heading">

              <div className="cake-login-heading-icon">
                🎂
              </div>

              <h2>
                Vendor Login
              </h2>

              <p>
                Login to your VAKRA Cake account.
              </p>

            </div>


            {message && (
              <div
                className={
                  messageType === 'success'
                    ? 'cake-login-message success'
                    : 'cake-login-message error'
                }
              >
                {message}
              </div>
            )}


            <form
              className="cake-login-form"
              onSubmit={handleSubmit}
            >

              <div className="cake-login-form-group">

                <label>
                  Email Address
                </label>

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  autoComplete="email"
                />

              </div>


              <div className="cake-login-form-group">

                <label>
                  Password
                </label>

                <div className="cake-login-password-wrap">

                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                  />

                  <button
                    type="button"
                    className="cake-show-password-button"
                    onClick={() =>
                      setShowPassword((prev) => !prev)
                    }
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>

                </div>

              </div>


              <div className="cake-login-options">

                <label className="cake-remember-login">

                  <input
                    type="checkbox"
                  />

                  <span>
                    Remember me
                  </span>

                </label>

                <button
                  type="button"
                  className="cake-forgot-password"
                  onClick={() => {
                    setMessage(
                      'Forgot password feature will be added later.'
                    );

                    setMessageType('error');
                  }}
                >
                  Forgot Password?
                </button>

              </div>


              <button
                type="submit"
                className="cake-login-submit"
                disabled={loading}
              >
                {
                  loading
                    ? 'Logging In...'
                    : 'Login'
                }
              </button>


              <div className="cake-login-divider">

                <span></span>

                <p>
                  OR
                </p>

                <span></span>

              </div>


              <button
                type="button"
                className="cake-book-demo-login"
                onClick={() =>
                  navigate('/cake/book-demo')
                }
              >
                Book a Demo
              </button>


              <div className="cake-login-bottom">

                Don't have an account?

                <button
                  type="button"
                  onClick={() =>
                    navigate('/cake/signup')
                  }
                >
                  Create Account
                </button>

              </div>

            </form>

          </div>

        </section>

      </main>

    </div>
  );
};

export default CakeLogin;
